import { PortableText, type PortableTextProps } from "next-sanity";
import { MDX } from "./MDX";

/* -----------------Utils--------------- */
import { cn } from "@/lib/utils";
import { type Size, Sizes, textStyles } from "./styles";

export type AdaptiveTextProps = {
	mdx?: string;
	portableText?: PortableTextProps["value"];
	as?: React.ElementType;
	className?: string;
	components?: PortableTextProps["components"];
	size?: Size;
};

export const AdaptiveText = ({
	mdx,
	portableText,
	as,
	components,
	size = Sizes.Section,
	className,
}: AdaptiveTextProps) => {
	const Component = as ?? "div";

	if (portableText) {
		return (
			// @ts-ignore: // TODO: fix this
			<Component
				// @ts-ignore: // TODO: fix this
				className={cn("font-medium", textStyles[size], className)}
			>
				<PortableText value={portableText} components={components} />
			</Component>
		);
	}

	if (mdx) {
		return (
			// @ts-ignore: // TODO: fix this
			<Component
				// @ts-ignore: // TODO: fix this
				className={cn("font-medium", textStyles[size], className)}
			>
				<MDX value={mdx} />
			</Component>
		);
	}

	return null;
};
